import React, { useEffect, useState } from "react";

export default function LiveTimer({
  startTime,
  accumulatedSeconds = 0,
  isRunning = false,
}: {
  startTime?: string | Date | null;
  accumulatedSeconds?: number;
  isRunning?: boolean;
}) {
  const [elapsed, setElapsed] = useState(accumulatedSeconds);

  useEffect(() => {
    // Sync starting elapsed time whenever props change
    let initialElapsed = accumulatedSeconds;
    if (isRunning && startTime) {
      const startMs = new Date(startTime).getTime();
      const nowMs = new Date().getTime();
      initialElapsed += Math.floor((nowMs - startMs) / 1000);
    }
    setElapsed(initialElapsed);

    if (!isRunning) return;

    const interval = setInterval(() => {
      setElapsed((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime, accumulatedSeconds, isRunning]);

  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    if (h > 0)
      return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  return <span className="font-mono">{formatTime(elapsed)}</span>;
}
